import React from 'react'
// components
import TableManagementProvider from 'containers/Search/layers/BL'
import Objectives from 'components/PageComponents/Objectives'
// context
import ObjectivesPageAPI from 'containers/Objectives/Register/layers/API'

const ObjectivesContainer: React.FC = () => (
  <TableManagementProvider>
    <ObjectivesPageAPI>
      <Objectives />
    </ObjectivesPageAPI>
  </TableManagementProvider>
)

export default ObjectivesContainer
